<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3 pl-sm-1"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="ma-3" :style="maxHeight">
        <v-tabs
            v-model="tab"
            background-color="#EBEFFD"
            centered
            show-arrows
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#groups">
            Groups
          </v-tab>
          <v-tab href="#outlets">
            Outlets
          </v-tab>
          <v-tab href="#admins">
            Admins
          </v-tab>
          <v-tab href="#sms">
            SMS Statistic
          </v-tab>
          <v-tabs-items
              v-model="tab"
          >
            <v-tab-item
                :key="1"
                :value="'groups'"
            >
              <v-card>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                        v-model="searchGroups"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                        autocomplete="off"
                        dense
                    ></v-text-field>
                  </v-col>
                  <v-col style="text-align: right;" class="pr-12">
                    <v-btn class="ma-1 font-weight-bold"
                           color="success"
                           @click="createGroup()"> + Add Group
                    </v-btn>
                  </v-col>
                </v-row>
                <v-card
                >
                  <v-data-table
                      :headers="groupsHeaders"
                      item-key="id"
                      :items="Object.values(groups)"
                      :search="searchGroups"
                      dense
                      class="display-3 font-weight-medium"
                      :items-per-page="30"
                      :fixed-header="true"
                      height="450"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                          class="mr-8"
                          @click="editGroup(item)"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                          color="red"
                          @click="deleteGroup(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card>
            </v-tab-item>
            <v-tab-item
                :key="2"
                :value="'outlets'"
            >
              <v-card>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                        v-model="searchOutlets"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                        autocomplete="off"
                        dense
                    ></v-text-field>
                  </v-col>
                  <v-col style="text-align: right;" class="pr-12">
                    <v-btn class="ma-1 font-weight-bold"
                           color="success"
                           @click="createOutlet()"> + Add Outlet
                    </v-btn>
                  </v-col>
                </v-row>
                <v-card
                >
                  <v-data-table
                      :headers="outletsHeaders"
                      item-key="id"
                      :items="Object.values(outlets)"
                      :search="searchOutlets"
                      dense
                      class="display-3 font-weight-medium"
                      :items-per-page="30"
                      :fixed-header="true"
                      height="450"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                          class="mr-8"
                          @click="editOutlet(item)"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                          color="red"
                          @click="deleteOutlet(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card>
            </v-tab-item>
            <v-tab-item
                :key="3"
                :value="'admins'"
            >
              <v-row>
                <v-col cols="6">
                  <v-text-field
                      v-model="searchAdmins"
                      append-icon="mdi-magnify"
                      label="Search"
                      hide-details
                      class="ma-1"
                      outlined
                      autocomplete="off"
                      dense
                  ></v-text-field>
                </v-col>
                <v-col style="text-align: right;" class="pr-12">
                  <v-btn class="ma-1 font-weight-bold"
                         color="success"
                         @click="createAdmin()"> + Add Admin
                  </v-btn>
                </v-col>
              </v-row>
              <v-card
              >
                <v-data-table
                    :headers="adminsHeaders"
                    :items="admins"
                    :search="searchAdmins"
                    dense
                    class="display-3 font-weight-medium"
                    :items-per-page="30"
                    :fixed-header="true"
                    height="450"
                >
                  <template
                      v-slot:item.group_id="{ item}"
                  >
                    <span>{{ getGroupName(item.group_id) }}</span>
                  </template>
                  <template
                      v-slot:item.role_id="{ item}"
                  >
                    <span>{{ getRoleName(item.role_id) }}</span>
                  </template>
                  <template
                      v-slot:item.actions="{ item }"
                  >
                    <v-icon
                        class="mr-8"
                        @click="editAdmin(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                        color="red"
                        @click="deleteAdmin(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab-item
                :key="4"
                :value="'sms'"
            >
              <sms-statistic
                  :groups="groups"
                  :outlets="outlets"
              ></sms-statistic>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'superadmin-panel',
  props: [
    'groups', 'outlets', 'admins'
  ],
  data: () => ({
    groupsData: [],
    outletsData: [],
    adminsData: [],
    roles: [],
    tab: null,
    searchGroups: null,
    searchOutlets: null,
    searchAdmins: null,
    groupsHeaders: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      {
        text: 'Group Name',
        value: 'name',
      },
      {
        text: 'Description',
        value: 'description',
      },
      {
        text: 'SubDomain',
        value: 'subdomain',
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false
      }
    ],
    outletsHeaders: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      {
        text: 'Outlet Name',
        value: 'name',
      },
      {
        text: 'Description',
        value: 'description',
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false
      }
    ],
    adminsHeaders: [
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Group',
        value: 'group_id',
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Role',
        value: 'role_id'
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false
      }
    ],
    breadcrumbsItems: []
  }),
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
    maxHeight() {
      return {
        maxHeight: window.innerHeight + 'px'
      }
    }
  },
  methods: {
    editGroup(g) {
      window.location.href = '/group/' + g.id + '/edit'
    },
    editOutlet(o) {
      window.location.href = '/outlet/' + o.id + '/edit'
    },
    editAdmin(a) {
      window.location.href = '/admin/' + a.id + '/edit'
    },
    deleteGroup(g) {
      const i = this.groups.indexOf(g);
      if (confirm('Are you sure you want to delete this group?')) {
        axios.delete('/group/' + g.id).then(response => {
          this.groups.splice(i, 1);
        });
      }
    },
    deleteOutlet(o) {
      const i = this.outlets.indexOf(o);
      if (confirm('Are you sure you want to delete this outlet?')) {
        axios.delete('/outlet/' + o.id).then(response => {
          this.outlets.splice(i, 1);
        });
      }
    },
    deleteAdmin(a) {
      const i = this.admins.indexOf(a);
      if (confirm('Are you sure you want to delete this admin?')) {
        axios.delete('/admin/' + a.id).then(response => {
          this.admins.splice(i, 1);
        });
      }
    },
    createGroup() {
      window.location.href = '/group/create'
    },
    createOutlet() {
      window.location.href = '/outlet/create'
    },
    createAdmin() {
      window.location.href = '/admin/create'
    },
    getGroupName(gid) {
      let groupName = '';
      if (this.groups.length > 0) {
        this.groups.forEach(function (item, index) {
          if (item.id === gid) {
            groupName = item.name
          }
        })
      }
      return groupName
    },
    getRoleName(role_id) {
      let roleName = '';
      if (this.roles.length > 0) {
        this.roles.forEach(function (item, index) {
          if (item.id === role_id) {
            roleName = item.name
          }
        })
      }
      return roleName
    }

  },
  beforeMount() {
    this.groupsData = this.groups;
    this.outletsData = this.outlets;
    this.adminsData = this.admins;
    axios.get('/api/getRoles').then(response => {
      this.roles = response.data;
    })
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      }
    ];
  }
}
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SuperadminPanel.vue